import StockScreenComponent from "./StockScreenComponent";
import DataSource, {DataSourceOptions} from "devextreme/data/data_source";
import {iRootDispatch, iRootState} from "../../../store/store";
import {RouteComponentProps, withRouter} from "react-router";
import {connect} from "react-redux";
import {select} from "../../../store/store";
import {WMSBasicStocksStore} from "../../../store/models/WMSBasicStocksModel";

export type StockScreenGridItemData =
    {
        id: string,
        totalAvailableProductUnitsSum: number,
        productName: string,
        totalLockedProductUnitsSum: number,

        attributeGroups: {
            attributeName: "string",
            attributeType: number,
            //
            attributeWarehouseStocks:
                {
                    attributeValue: "string",
                    warehouseStock:
                        {
                            warehouseId: "string",
                            availableUnits: number,
                            lockedUnits: number,
                            warehouseName: "string"
                        }[]
                }[]
        }[]
    }

export interface StockScreenStateProps {
    createStockDataSource: () => Array<any> | DataSource | undefined;
}

export interface StockScreenDispatchProps {

}

const selection = () => select((_models) => ({}))


const mapStateToProps = (state: iRootState, ownProps: RouteComponentProps<{}>): StockScreenStateProps => ({
    createStockDataSource: () => {
        return new DataSource({
            store: WMSBasicStocksStore,
            map: (dataItem: StockScreenGridItemData) => {
                let item = dataItem as any;
                //
                item.details = {} as any;
                item.flatAttributes = [] as any;
                //
                dataItem.attributeGroups.forEach((ag) => {
                    item.details[ag.attributeName] = ag.attributeWarehouseStocks
                    //
                    ag.attributeWarehouseStocks.forEach(aw => {
                        let a = {} as any;
                        //
                        a["attributeName"] = ag.attributeName;
                        a["attributeValue"] = aw.attributeValue;
                        //
                        a["warehouseStock"] = aw.warehouseStock;
                        //
                        item.flatAttributes.push(a)
                    })
                })
                //
                return item;
            }
        })
    },
    //
    ...selection()(state),
})

const mapDispatch = (_dispatch: iRootDispatch, _ownDispatch: StockScreenDispatchProps) => ({

    ..._ownDispatch
} as StockScreenDispatchProps);

export type connectedProps =
    StockScreenStateProps
    & ReturnType<typeof mapDispatch>
export type StockScreenProps = connectedProps

export const StockScreen = withRouter(connect(
    mapStateToProps,
    mapDispatch as any
)(StockScreenComponent));

export const StockScreenWithoutRouter = connect(
    mapStateToProps,
    mapDispatch as any
)(StockScreenComponent);
